import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AbstractDynamicInput } from '../abstract-dynamic-input';

@Component({
    selector: 'odq-dynamic-text',
    templateUrl: './dynamic-text.component.html',
    styleUrls: ['./dynamic-text.component.scss'],
    standalone: false
})
export class DynamicTextComponent extends AbstractDynamicInput {

  constructor(translate: TranslateService) { super(translate) }

}